import classnames from "classnames";
import { nanoid } from "nanoid";
import CustomIcon from "../../../components/core/CustomIcon/CustomIcon";
import CustomImage from "../../../components/core/CustomImage/CustomImage";
import tickIcon from "../../../assets/icons/tick_greencircle.svg";
import featurelist from "../../../assets/images/featurelist.png";
import { standardfeatures } from "../../../global/constant";
import Button from "../../../components/core/Button/Button";
import classes from "../../../styles/Subscription.module.scss";
import useIsMobile from "../../../components/hooks/useIsMobile";
import { APP_PATH } from "../../../routes/route";
import { useNavigate } from "react-router";

function StandardFeatures() {
  const navigate = useNavigate();
  const isMobile = useIsMobile({ breakpoint: 768 });
  return (
    <div className={classnames(classes.standardFeatureBlock)}>
      <CustomImage
        src={featurelist}
        style={{ maxWidth: isMobile ? "unset" : 400 }}
        width="100%"
      />
      <div className={classes.standardFeatureList}>
        <div className={classes.heading}>
          All plans come with the Standard features
        </div>
        <div className={classnames(classes.list)}>
          {standardfeatures.map((feature) => {
            return (
              <div key={nanoid()} className={classnames(classes.listblock)}>
                <CustomIcon src={tickIcon} iconHeight={16} iconWidth={16} />
                <div className={classnames(classes.featureName)}>{feature}</div>
              </div>
            );
          })}
        </div>
        <Button
          clickHandler={() => navigate(`${APP_PATH}/subscription/form`,
                                            {state:{plan:"Free trial",planType:"TRIAL"}})}
          label="Start your free trial"
          className={classes.freetrialbtn}
        />
      </div>
    </div>
  );
}

export default StandardFeatures;
